var PromoCodeView = (function (BaseView) {
	return BaseView.extend({
		el: '@giftVoucher',

        hiddenBlock: 'hidden-block',

		events: {
			'paste @giftVoucherInput': '_onChangePromoCode',
			'keyup @giftVoucherInput': '_onChangePromoCode',
			'mouseup @giftVoucherInput': '_onChangePromoCode',
            'click @giftVoucherApply': '_apply'
		},

        initialize: function() {
            _.bindAll(this, '_apply', '_onChangePromoCode', '_clear');
            
            this.$input = this.$('@giftVoucherInput');
            this.$button = this.$('@giftVoucherApply').addClass(this.hiddenBlock);
        },

		_onChangePromoCode: function() {
		    var _this = this;
		    setTimeout(function() {
		        var value = _this.$input.val();
		        _this.$button.toggleClass(_this.hiddenBlock, !value);
		    }, 0);
		},

		_apply: function () {
			var value = this.$input.val();
			if (value) {
				this.model.apply(value).done(this._clear);
			}
		},

		_clear: function () {
			this.$input.val('');
		    this.display('checkout');
		}
	});
})(BaseView);